<template>
  <div class="explanation">
      <p v-html="content.text"></p>
      <Button v-if="displayButton" v-html="button" :action="'next'" :colors="button_colors" @next="update" />
    </div>
</template>

<script>
import Button from './Button.vue'

export default {
  name: 'Explanation',
  components: {
      Button
  },
  props: ['content','button','button_colors'],
  mounted: function(){
      var timer = this.countWords(this.content.text) * 462;
      if(timer <= 2000 )timer = 2000;
      else if(timer >= 12000)timer = 12000;
      if(this.button !== true && this.button !== 'true'){
          this.showButton = true;
      }else{
            setTimeout( ()=> {
                this.$emit('next')
            }, ( timer ) )//average reading time 130 words per minute
      }
  },
  data: function(){
      return {
        showButton: false,
        progress: null
      }
  },
  methods: {
    update(){
        this.$emit('next')
    },
    countWords(str) {
        str = str.replace(/(^\s*)|(\s*$)/gi,"");
        str = str.replace(/[ ]{2,}/gi," ");
        str = str.replace(/\n /,"\n");
        return str.split(' ').length;
    }
  },
  computed: {
      displayButton: function(){
          return this.showButton;
      }
  }
}
</script>
